import { useState } from 'react';
import { toggleTheme, type Theme } from '../../lib/theme.js';

export function ThemeToggle({ className = '' }: { className?: string }) {
  const [theme, setThemeState] = useState<Theme>(
    document.documentElement.dataset.theme === 'light' ? 'light' : 'dark',
  );
  return (
    <button
      type="button"
      className={`btn btn-ghost theme-toggle ${className}`}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={() => setThemeState(toggleTheme())}
    >
      {theme === 'dark' ? '☀' : '☾'}
    </button>
  );
}
